import { Logo } from '@/components/shared/Logo/Logo';
import { cn } from '@/utils';
import { type PropsWithChildren } from 'react';

export const GenericLayout = ({
  children,
  className,
  mainProps,
  isAnchor = false,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & PropsWithChildren<{ isAnchor?: boolean; mainProps?: React.HTMLAttributes<HTMLDivElement> }>) => {
  return (
    <div
      data-testid='generic-layout'
      className={cn('tablet:bg-fill-background-light bg-fill-background-neutral flex h-full min-h-screen flex-col', className)}
      {...props}
    >
      <header className='desktop:p-8 flex w-full px-5 py-4'>
        <Logo variant={isAnchor ? 'anchor' : 'link'} />
      </header>
      <main
        {...mainProps}
        className={cn('tablet:mt-10 desktop:mt-16 tablet:pb-8 mt-0 flex w-full flex-1 flex-col items-center', mainProps?.className)}
        role='main'
      >
        {children}
      </main>
    </div>
  );
};
